import React, { useState, useEffect } from 'react';
import { Input, Spin, Form } from "antd";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import columns from "../../../columns/ib/Kyc.js";
import Segmented from "../../../components/segmented/Segmented.jsx";
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import moment from 'moment/moment.js';
import { KycManager, KycRequestAcceptRejectApi, GetAllKycByIdApi } from '../../../api/request/ib/kycManager.js';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx'
import Eye from "../../../assets/Eye.jsx";
import Download from "../../../assets/Download.jsx";
import { exportData } from "../../../services/ExportHandler.js";
import { handleApiError } from '../../../utils/handleApiError.js';
import { useResponsive } from '../../../hooks/useResponsive.js';
const { TextArea } = Input;

export default function KYCManager() {
  const [rejectForm] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');
  const [selectedKycId, setSelectedKycId] = useState('');
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [value, setValue] = useState('Pending');
  const [kycRejection, setKycRejection] = useState(false);
  const [kycAccept, setKycAccept] = useState(false);
  const [isReqLoading, setIsReqLoading] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isKycDetailsLoading, setIsKycDetailsLoading] = useState(false);
  const [kycDetails, setKycDetails] = useState({});
  const [isOpenModalimg, setIsOpenModalimg] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });
  const { isMobile } = useResponsive();

  const getAllKyc = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        searchText: searchText,
        FilterText:
          value === "Pending"
            ? "Pending"
            : value === "Approved"
              ? "Approved"
              : value === "Declined"
                ? "Rejected"
                : value,
        ...sorter
      }
      const { data } = await KycManager(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(data?.data?.map((item) => {
          return ({
            ...item,
            name: `${item?.firstName} ${item?.lastName}`,
            requestDate: item?.requestDate ? moment(item?.requestDate).format('DD-MM-YYYY LT') : null,
            actionDate: item?.actionDate ? moment(item?.actionDate).format('DD-MM-YYYY LT') : null,
            actions: (<div className='cursor-pointer' onClick={() => { setSelectedKycId(item?.userId); setIsOpenModal(true) }}><Eye /></div>)
          })
        }))
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'requestDate', SortOrder: '' });
    }
  };

  useEffect(() => {
    getAllKyc();
  }, [page, pageSize,searchText, value, sorter]);

  const kycRequestHandlerApproved = async (value) => {
    if (!value) {
      if (!textAreaValue) {
        toast.error("Please enter a reason.");
        return;
      }
    }
    try {
      setIsReqLoading(true);
      let params = {
        isRejected: false,
        isApproved: true,
        comment: textAreaValue ? textAreaValue : "Accepted.",
        userId: selectedKycId,
      };
      const { data } = await KycRequestAcceptRejectApi(params);
      if (data?.success) {
        toast.success(data?.message);
        getAllKyc();
        setIsOpenModal(false);
        setTextAreaValue("");
      }
      setIsReqLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsReqLoading(false);
    }
    if (value) {
      setKycAccept(false);
    } else {
      setKycRejection(false);
    }
  };

  const kycRequestHandlerRejected = async (value) => {
    if (!value) {
      if (!textAreaValue) {
        toast.error("Please enter a reason.");
        return;
      }
    }
    try {
      setIsReqLoading(true);
      let params = {
        isRejected: true,
        isApproved: false,
        comment: textAreaValue ? textAreaValue : "Accepted.",
        userId: selectedKycId,
      };
      const { data } = await KycRequestAcceptRejectApi(params);
      if (data?.success) {
        toast.success(data?.message);
        getAllKyc();
        setIsOpenModal(false);
        setKycRejection(false)
        setTextAreaValue("");
      }
      setIsReqLoading(false);
    } catch (error) {
      handleApiError(error);
      setIsReqLoading(false);
    }
    if (value) {
      setKycAccept(false);
    } else {
      setKycRejection(false);
    }
  };

  const getKycById = async () => {
    try {
      setIsKycDetailsLoading(true);
      const { data } = await GetAllKycByIdApi(selectedKycId);
      setKycDetails(data?.data);
      setIsKycDetailsLoading(false);
    } catch (error) {
      setIsKycDetailsLoading(false);
    }
  };

  const exportHandler = async () => {
    try {
      setIsExportLoading(true);
      let params = {
        ApplyPagination: false,
        searchText: searchText.toLowerCase().replace(/\s/g, ''),
        FilterText:
          value === "Pending"
            ? "Pending"
            : value === "Approved"
              ? "Approved"
              : value === "Declined"
                ? "Rejected"
                : value,
        ...sorter
      };
      const { data } = await KycManager(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        let columnOrder = ['name', 'firstName', 'lastName', 'email', 'phoneNo', 'address', 'countryName', 'parentName', 'passport', 'nationalId', 'drivingLicense', 'utilityBill', 'bankStatement', 'comment', 'isApproved', 'isRejected', 'requestDate', 'actionDate', 'actionBy', 'isAccount', 'isDeposit', 'isKyc', 'kycStatus', 'kycType', 'userType'];
        exportData(data?.data, "KYC List", columnOrder);
      }
      setIsExportLoading(false);
    } catch (error) { }
  };

  useEffect(() => {
    if (selectedKycId) {
      getKycById();
    }
  }, [selectedKycId]);

  useEffect(() => {
    setSearchParams(`filter=${value?.toString()}`);
  }, [value]);

  useEffect(() => {
    if (searchParams?.get("filter")?.trim()) {
      setValue(searchParams?.get("filter")?.trim());
    }
  }, []);

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center flex-wrap gap-5">
        <div className="w-full md:w-auto">
          <Segmented
            options={["Pending", "Approved", "Declined"]}
            value={value}
            setValue={setValue}
            block={isMobile}
          />
        </div>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">
          <Input
            size="large"
            className="w-full sm:w-[220px]"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={() => setSearchText(search)}
            prefix={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                  clipRule="evenodd"
                />
              </svg>
            }
            suffix={
              search && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => { setSearchText(""); setSearch(""); }}
                  viewBox="0 0 24 24"
                  fill="#bebebe"
                  className="size-5 cursor-pointer duration-300 hover:fill-[#969595]"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                    clipRule="evenodd"
                  />
                </svg>
              )
            }
          />
          <LoadableButton
            className={`bg-primary text-sm text-white font-semibold px-4 py-2 rounded-lg themeHover duration-500 ${isMobile ? 'w-full' : ''}`}
            onClick={exportHandler}
            img={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z"
                  clipRule="evenodd"
                />
              </svg>
            }
            disabled={isExportLoading}
            lable="Export"
            isLoading={isExportLoading}
            loadingLable="Exporting..."
          />
        </div>
      </div>

      <div className="w-full">
        <div className="my-6">
          <div className="border border-gray-200 rounded-xl"> 
              <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange}/>
          </div>
          <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
      </div>
      {/* ---- Accept-request ---- */}
      <ConfirmationModal
        isOpen={kycAccept}
        setIsOpen={setKycAccept}
        type="success"
        message="Are you sure you want to accept this request?"
        onConfirm={() => kycRequestHandlerApproved(true)}
        isLoading={isReqLoading}
        loadingLabel="Accepting request..."
      />

      {/* ---- Reject-request ---- */}

      {/* Reject Account request modal */}
      <ModalComponent isOpen={kycRejection} setIsOpen={setKycRejection} title={'Are you sure you want to reject this request?'} width={600}>
        <Form form={rejectForm} initialValues={textAreaValue} onFinish={kycRequestHandlerRejected}>
          <label className='text-base text-[#2F2B3DCC] font-medium'>Reason of rejection</label>
          <Form.Item name="comment" rules={[{ required: true, message: 'Please enter comment.' }]}>
            <TextArea rows={4} placeholder='Describe reason...' />
          </Form.Item>
          <div className='flex items-center justify-end gap-5 mt-5'>
            <button type='button' onClick={() => setKycRejection(false)} className='bg-secondary text-sm text-white font-semibold px-6 py-2 rounded-lg themeSecondaryHover duration-500'>Cancel</button>
            <LoadableButton
              type='submit'
              className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
              lable='Reject'
              loadingLable='Rejecting request...'
              isLoading={isLoadingSubmit}
            />
          </div>
        </Form>
      </ModalComponent>

      {/* ---- KYC Information ---- */}
      <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title="KYC Information" width={1300}>
        {
          isKycDetailsLoading ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div className='p-5'>
              <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                <div>
                  <p className='text-base font-normal '>First Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.firstName || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Last Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.lastName || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '> User Type</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.userType || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Created Time</p>
                  <p className='text-xl primary font-semibold  mt-2'> {kycDetails?.requestDate ? moment(kycDetails?.requestDate).format("DD-MM-YYYY LT")
                    : "--"}</p>
                </div>
                {kycDetails?.kycStatus === "Approved" ? <div>
                  <p className='text-base font-normal '>Approved Time</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.actionDate ? moment(kycDetails?.actionDate).format("DD-MM-YYYY LT") : "--"}</p>
                </div> : ""}
                {kycDetails?.kycStatus === "Rejected" ? <div>
                  <p className='text-base font-normal '>Declined Time</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.actionDate ? moment(kycDetails?.actionDate).format("DD-MM-YYYY LT") : "--"}</p>
                </div> : ""}
                <div>
                  <p className='text-base font-normal '>Mobile No.</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.phoneNo || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Email</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.email || "--"}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Kyc Status</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.kycStatus || '--'}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Country Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.countryName || "--"}</p>
                </div>
                {
                  kycDetails?.kycType == 'manual' &&
                  <div>
                    <p className="text-[#1E232CC7] text-lg">Document</p>
                    <div className="flex items-center cursor-pointer" onClick={() => setIsOpenModalimg(true)}>
                      <p className="primary text-lg font-semibold mt-2 underline mr-2">View Document</p>
                    </div>
                  </div>
                }
                {/* <div>
                  <p className='text-base font-normal '>Kyc Verified</p>
                  <p className='text-xl primary font-semibold  mt-2'> {kycDetails?.isKyc === true ? "Yes" : "No" || "--"}</p>
                </div> */}
              </div>
              {kycDetails?.isKyc === false ? (
                <div className="flex justify-center items-center">
                  <div className="mt-8">
                    <button
                      onClick={() => { setSelectedKycId(kycDetails?.userId); setKycAccept(true) }}
                      className="bg-[#2D9B6333] text-sm text-[#2D9B63] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#2D9B63] hover:text-white duration-500"
                    >
                      Accept
                    </button>
                    <button
                      onClick={() => { setSelectedKycId(kycDetails?.userId); setKycRejection(true) }}
                      className="bg-[#F8222333] text-sm text-[#F82223] font-semibold px-4 py-2 rounded-lg uppercase hover:bg-[#F82223] hover:text-white duration-500 ml-4"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              ) : (null)}
              {kycDetails?.kycStatus === "Rejected" ? <div className="mt-4">
                <p className='text-base font-normal '>Comment</p>
                <p className='text-xl primary font-semibold  mt-2'>{kycDetails?.comment || "--"}</p>
              </div> : ""}
            </div>
          )
        }
      </ModalComponent>

      {/* View Document */}
      <ModalComponent isOpen={isOpenModalimg} setIsOpen={setIsOpenModalimg} title="View Document" width={1000}>
        {
          isKycDetailsLoading ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div>
              {kycDetails?.fileUrlPath && kycDetails.fileUrlPath.length > 0 ? (
                <div className='p-5'>
                  <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10'>
                    {kycDetails.fileUrlPath.map((url, index) => (
                      <div key={index} className="border border-gray-300 rounded-lg">
                        <img src={url} alt={`KYC Document ${index + 1}`} className="w-full h-auto rounded-lg cursor-pointer" onClick={() => openInNewTab(url)} />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p>No documents available</p>
              )}
            </div>

          )
        }
      </ModalComponent>
    </div>
  )
}